import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const getAllByPaciente = async (idPaciente) => {

  const query = `
    query fetchHistorial($idPaciente : ID) {
      getAntperanamIdpaciente(idpaciente: $idPaciente) {
        message
        status
        apersonales {
          id
          estado
          anio
          descripcionGeneral
          antescedentesPersonales {
            descripcion
            tipoAntecedente
            id
          }
          consultamedica {
            id
            token
            cita {
              id
              paciente {
                id
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    idPaciente
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if( response.status !== 200) return null;
    const response2 = response.data.data.getAntperanamIdpaciente;
    if(response2.status !== 'success') return null;

    const data = response2.apersonales;
    return data;

  } catch (error) {
    console.error('Error en getHistorialAFamiliaresByPaciente', error);
    return null;
  }
}


export const antPersonalesService = {
  getAllByPaciente,
};